export default __webpack_public_path__ + "static/media/pin.f591ddf4.svg";